import React from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import Button from 'components/ui/button/button';
import './popup-group-warning.scss';

const PopupGroupWarning = ({languageId, deviceInfo, goToNextPage, setShowWarningPopup}) => {
 
	return (
		<div className={'PopupGroupWarning ' + deviceInfo.orientation}>
			<div className="PopupGroupWarning-content">
				<div className="PopupGroupWarning-text">
					{renderMarkdown(getText('general_groupWarningText', languageId))}
				</div>
				
				<div className="PopupGroupWarning-buttons">
					<div className="PopupGroupWarning-button yes">
						<Button 
							text={getText('general_yesContinue', languageId)} 
							classes={['orange']} 
							onClick={() => {goToNextPage();}} 
						/>
					</div>
					<div className="PopupGroupWarning-button no">
						<Button 
							text={getText('general_noCancel', languageId)} 
							classes={['orange']} 
							onClick={() => {setShowWarningPopup(false);}} 
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

PopupGroupWarning.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	goToNextPage: PropTypes.func.isRequired,
	setShowWarningPopup: PropTypes.func.isRequired,
};

export default PopupGroupWarning;
